import custIndustryReport from './custIndustryReport'
export default custIndustryReport
